import { Image, theme, Typography } from "antd";
import { RoboticAgent, SeriousFace, User } from "../../../assets";
import {
  ColumnComponent,
  ContainerComponent,
  RowComponent,
  TabbarComponent,
} from "../../../components";
import RenderMarkdown from "../../../components/render-markdown.component";
import { MetricPartial } from "./metric.partial";
import { SuccessCasesPartial } from "./success-cases.partial";

export const ShowUseCaseContentPartial = ({ ...useCase }) => {
  const {
    token: { colorTextSecondary, colorBgContainer },
  } = theme.useToken();

  return (
    <div>
      <ColumnComponent style={{ marginTop: 16 }}>
        <RowComponent
          style={{
            gap: 32,
            backgroundColor: colorBgContainer,
            borderRadius: "32px",
            padding: 32,
            justifyContent: "space-between",
          }}
        >
          <TabbarComponent
            style={{ minWidth: "65%", maxWidth: "65%" }}
            tabs={[
              {
                key: "1",
                label: "Descripción",
                children: useCase.description ? (
                  <RenderMarkdown markdownContent={useCase.description} />
                ) : (
                  <Typography.Text
                    style={{
                      textAlign: "start",
                      display: "inherit",
                      color: colorTextSecondary,
                    }}
                  >
                    Sin descripción
                  </Typography.Text>
                ),
              },
              {
                key: "2",
                label: "Prompt",
                children: useCase.prompt ? (
                  <RenderMarkdown markdownContent={useCase.prompt} />
                ) : (
                  <Typography.Text
                    style={{
                      textAlign: "start",
                      display: "inherit",
                      color: colorTextSecondary,
                    }}
                  >
                    Sin prompt
                  </Typography.Text>
                ),
              },
              {
                key: "3",
                label: "Pasos del proceso",
                children: useCase.steptProblem ? (
                  <RenderMarkdown markdownContent={useCase.steptProblem} />
                ) : (
                  <Typography.Text
                    style={{
                      textAlign: "start",
                      display: "inherit",
                      color: colorTextSecondary,
                    }}
                  >
                    Sin pasos del proceso
                  </Typography.Text>
                ),
              },
            ]}
          />
          <SuccessCasesPartial useCase={useCase} />
        </RowComponent>

        <ColumnComponent
          style={{
            marginTop: 32,
            padding: 32,
            borderRadius: 32,
            backgroundColor: colorBgContainer,
          }}
        >
          <Typography.Title level={4} style={{ alignSelf: "start" }}>
            Metricas clave
          </Typography.Title>
          <RowComponent
            style={{
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {<MetricPartial
              label="Tiempo estimado de desarrollo"
              color={"#33395D"}
              data={useCase.estimatedDevelopmentTime}
            />}
            <MetricPartial
              label="Incidencias Por Mes"
              color={"#33395D"}
              icon={<SeriousFace size={32} color="black" />}
              data={useCase.incidentsPerMonth}
            />
            <MetricPartial
              label="Mejora de tiempo"
              color={"#EE3A4C"}
              icon={<User size={32} color="black" />}
              data={useCase.currentManualTicketTime}
            />
            <MetricPartial
              label="Con agente"
              color={"#01B574"}
              icon={<RoboticAgent size={32} color="black" />}
              data={useCase.newAgentTicketTime}
            />
          </RowComponent>
        </ColumnComponent>
      </ColumnComponent>

      {useCase.demoUrl?.trim() && (
        <ColumnComponent
          style={{
            marginTop: 32,
            padding: 32,
            borderRadius: 32,
            backgroundColor: colorBgContainer,
          }}
        >
          <Typography.Title level={4} style={{ alignSelf: "start" }}>
            Video del caso
          </Typography.Title>
          <ContainerComponent
            style={{
              width: "100%",
              aspectRatio: "16 / 9",
              overflow: "hidden",
              borderRadius: 16,
            }}
          >
            <embed
              src={useCase.demoUrl}
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          </ContainerComponent>
        </ColumnComponent>
      )}

      <ColumnComponent
        style={{
          marginTop: 32,
          padding: 32,
          borderRadius: 32,
          backgroundColor: colorBgContainer,
        }}
      >
        <Typography.Title level={4} style={{ alignSelf: "start" }}>
          Casos de éxito
        </Typography.Title>
        <ContainerComponent>
          <Image
            src={useCase.diagramFlowUrl}
            style={{ maxHeight: "300px", objectFit: "cover" }}
          />
        </ContainerComponent>
      </ColumnComponent>
    </div>
  );
};
